import { CommandDispatcher } from "../../shared/domain/CommandDispatcher";

export class ExtendTrialDocsCommand {
  constructor(
    private readonly dispatcher: CommandDispatcher,
  ) {}

  run(extra_credits: number, reason: string, staff_username: string, contract_kind: string): Promise<{ [key: string]: object; }> {
    let args = {
      extra_credits: extra_credits,
      reason: reason,
      staff_username: staff_username,
      contract_kind: contract_kind
    };
    try {
      return this.dispatcher.dispatch('extend.trial.docs', args);
    } catch(error) {
      console.error('Error al extender créditos de prueba', error)
    }
  }
}
